<template>
  <div class="qrcode-container">
    <el-card class="box-card">
      <el-form label-width="80px">
        <el-form-item label="内容">
          <el-input v-model="content" placeholder="请输入内容" class="input-area"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="createQrCode">生成二维码</el-button>
          <el-button type="danger" @click="contentClean">清除</el-button>
        </el-form-item>
      </el-form>
      <div class="qrcode-display" v-if="url">
        <el-image
          style="width: 200px; height: 200px"
          :src='url'
          :fit="content"></el-image>
      </div>
    </el-card>
  </div>
</template>

<script>
import {createQrCode} from '../api/qrcode'
export default {
  name: 'qrcode',
  data () {
    return {
      content: '',
      url: ''
    }
  },
  methods: {
    contentClean () {
      this.content = ''
      this.url = ''
    },
    createQrCode () {
      createQrCode(this.content).then(response => {
        this.url = 'noauth/qr/get?id=' + response.data
      })
    }
  }
}
</script>

<style scoped>
.qrcode-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.box-card {
  max-width: 100%;
}
.input-area {
  width: 100%;
  max-width: 600px;
}
.qrcode-display {
  margin-top: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/qrcode.vue